import PropTypes from 'prop-types'

const allergenPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
})

allergenPropType.defaultProps = {
  description: undefined,
  synonyms: undefined,
  isExcludedFromSearch: false,
}

export default allergenPropType
